<template>
  <StatusBar/>
  <DisconnectPolicyOverlay/>
  <canvas></canvas>
  <div class="display-root" :style="{cursor: cursorValue}">
    <div
        class="layout-surface"
        :style="{
          opacity: store.loaded ? 1 : 0,
          pointerEvents: store.loaded ? 'auto' : 'none',
        }"
    >
      <ElementRenderer :elements="elements" :key="renderKey"/>
    </div>
    <Transition name="skeleton-fade">
      <Skeleton v-if="!store.loaded" class="reveal-skeleton"/>
    </Transition>
  </div>
  <Keyboard/>
  <SettingsModal/>
</template>

<script setup lang="ts">
import ElementRenderer from './ElementRenderer.vue';
import useStore from "../store.ts";
import Keyboard from "./Keyboard.vue";
import Skeleton from "./Skeleton.vue";
import StatusBar from "./StatusBar.vue";
import DisconnectPolicyOverlay from "./DisconnectPolicyOverlay.vue";
import SettingsModal from "./SettingsModal.vue";
import { useLoadingPhase } from "../utils/useLoadingPhase.ts";
import { useIdleCursor } from "../composables/useIdleCursor.ts";
import { useLayoutScale } from "../composables/useLayoutScale.ts";
import { useDisplayBoot } from "../composables/useDisplayBoot.ts";
import { useLayoutLifecycle } from "../composables/useLayoutLifecycle.ts";

const store = useStore();
// Invoked for its side effect: polls store.loadingDiagnostics for the Skeleton.
useLoadingPhase();
const { cursorValue } = useIdleCursor();
const { onResize } = useLayoutScale();
const { elements, renderKey } = useLayoutLifecycle({ onResize });
useDisplayBoot({ onResize });
</script>
<style>
#app {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}

.display-root {
  width: 100%;
  height: 100%;
  position: relative;
}

.layout-surface {
  width: 100%;
  height: 100%;
  transition: opacity 120ms ease, filter 400ms ease;
}

.reveal-skeleton {
  position: absolute;
  inset: 0;
}

.skeleton-fade-leave-active {
  transition: opacity 120ms ease;
}
.skeleton-fade-leave-to {
  opacity: 0;
}

.layout-loading-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  pointer-events: none;
  z-index: 10;
  background: rgba(245, 245, 247, 0.06);
}

.layout-loading-bar-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0%;
  background: linear-gradient(90deg, transparent, #3ABEF9 50%, #3ABEF9);
  box-shadow: 0 0 12px rgba(58, 190, 249, 0.45);
  transition: width 700ms cubic-bezier(.2,.7,.2,1);
}

.bar-fade-leave-active {
  transition: opacity 400ms ease;
}
.bar-fade-leave-to {
  opacity: 0;
}

</style>
